import { render } from "./skillList.vue?vue&type=template&id=f732d470&scoped=true"
import script from "./skillList.vue?vue&type=script&lang=js"
export * from "./skillList.vue?vue&type=script&lang=js"

import "./skillList.vue?vue&type=style&index=0&id=f732d470&scoped=true&lang=css"

import exportComponent from "C:\\Users\\NASTYFACT\\Desktop\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f732d470"]])

export default __exports__